(function($) {
	'use strict';

	var REQUEST_URLS;

	// If Styleguide Environment
	if (window.envStyleguide) {
		REQUEST_URLS = '/_sg-client/example_data/promo-code-inline.json';
	} else {
		REQUEST_URLS = {
			products:   '/api/sitecore/???'
		};
	}

	var SELECTORS = {
		promo:   '[data-promo-code]', 
		button:  '[data-promo-code-button]',
		input: '[data-promo-code-input]',
		msg:  '[data-promo-code-msg]'
	};

	var PROMO_RESPONSE = {
		success: '<i class="fa fa-check-circle-o"></i>',
		error: '<i class="fa fa-times"></i>'
	};


	// Shorthand selectors, converted to array
	var $promoInline = [].slice.call(document.querySelectorAll(SELECTORS.promo));

	// Show the message
	function showPromoMsg(element, input, value, form, button) {

		$.getJSON( REQUEST_URLS, function( promoJSON ) {
			var promoOKArray = promoJSON;
			var isPromoOK = promoOKArray.includes(value);
			var outerRow = form.parentNode.parentNode.parentNode;
			console.log(outerRow);
			var outerPromoMsg = outerRow.querySelectorAll('.online--printers-devices__promo-msg')[0];
			
			// Show the message
			function showMsg() {
				element.classList.add('show');
				element.setAttribute('aria-hidden', 'false');
			}
			
			if (isPromoOK) {
				element.innerHTML = PROMO_RESPONSE.success;
				input.disabled = true; // Disable input
				button.disabled = true; // Disable button
				outerPromoMsg.setAttribute('aria-hidden', 'false');
				outerRow.classList.add('promo-applied'); // Apply class to parent
				form.classList.add('success');
				showMsg();

			} else {
				form.classList.add('has-error');
				element.innerHTML = PROMO_RESPONSE.error;
				showMsg();
			}
			
		});

	}

	// Set up promo input
	function setupPromoInline(promoForm) {
		promoForm.addEventListener('submit', function(e) {
			var promoInput = promoForm.querySelectorAll(SELECTORS.input)[0];
			var promoValue = promoInput.value;			
			var promoButton = promoForm.querySelectorAll(SELECTORS.button)[0];
			var promoMsg = promoForm.querySelectorAll(SELECTORS.msg)[0];

			// Stop page refresh
			e.preventDefault();
			// Clear classes
			promoForm.classList = 'form-field-with-button--small';
			showPromoMsg(promoMsg, promoInput, promoValue, promoForm, promoButton);
			
		});
	}

	// If it exists, let's do stuff
	if($promoInline.length) {
		
		// For each, do this
		for (var i = 0; i < $promoInline.length; i++) {
		  setupPromoInline($promoInline[i]);
		}
	}
})($jq);
